import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { EntregasProjetoService } from '../services/entregas-projeto.service';

@Injectable({
  providedIn: 'root'
})
export class EntregasSimplificadaProjetoResolver implements Resolve<boolean> {

  constructor(private service: EntregasProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EntregasProjetoResolver implements Resolve<boolean> {

  constructor(private service: EntregasProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EntregasProjetoRelatorioResolver implements Resolve<boolean> {

  constructor(private service: EntregasProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const itens = this.service.getItensRelatorio();
    return this.service.getRelatorio(route.params.id, itens);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EntregasProjetoListResolver implements Resolve<boolean> {

  constructor(private service: EntregasProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EntregasProjetoListEditResolver implements Resolve<boolean> {

  constructor(private service: EntregasProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}






